import { BreadcrumbItem } from '@mitsubishi/shared/ui';

import { Selector } from '@ngxs/store';

import { PROJECT_BREADCRUMBS_STATE_TOKEN } from './breadcrumbs.model';

export class ProjectBreadcrumbsSelectors {
  @Selector([PROJECT_BREADCRUMBS_STATE_TOKEN])
  static getProjectBreadCrumbs(state: BreadcrumbItem[]) {
    return state;
  }
}
